var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-reviews--comments"},[(_vm.comments.length > 0)?_c('LadLimiter',{attrs:{"component":_vm.$options.components.LadReviewComment,"items":_vm.comments,"hide-less-btn":"","steps":10,"btn-block":"","inverse":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }